import axios from "axios";
import "./axiosInterceptor";

export const PASARELA = process.env.VUE_APP_URLPASARELA;

// Modo de muestra deliberadamente opt-in y disponible solo con el servidor
// de desarrollo. Permite revisar la lista y la campana sin consultar ni
// modificar avisos reales.
export function esDemoAvisos() {
  return process.env.NODE_ENV !== "production" &&
    new URLSearchParams(window.location.search).get("demoAvisos") === "1";
}

const imagenMuestra = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360" viewBox="0 0 640 360"><defs><linearGradient id="g"><stop stop-color="#9fd8df"/><stop offset="1" stop-color="#5fa8c4"/></linearGradient></defs><rect width="640" height="360" rx="28" fill="url(#g)"/><circle cx="520" cy="80" r="90" fill="#fff" opacity=".17"/><text x="48" y="150" fill="#fff" font-family="Arial,sans-serif" font-size="24" font-weight="700">NOVEDADES WEE!</text><text x="48" y="205" fill="#fff" font-family="Arial,sans-serif" font-size="42" font-weight="700">Todo más simple</text><text x="48" y="250" fill="#fff" font-family="Arial,sans-serif" font-size="20">Archivo de muestra para la vista</text></svg>'
)}`;

const paleta = [["#9fd8df", "#5fa8c4"], ["#b8c9e8", "#7f93c9"], ["#f2c9a8", "#d9967a"], ["#bfdcc4", "#7fb59a"]];
const imagenDemo = (titulo, i) =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="640" height="420"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="${paleta[i % 4][0]}"/><stop offset="1" stop-color="${paleta[i % 4][1]}"/></linearGradient></defs><rect width="640" height="420" fill="url(#g)"/><text x="40" y="230" fill="#fff" font-family="Arial" font-size="44" font-weight="700">${titulo} ${i + 1}</text></svg>`
  )}`;
const archivoImg = (titulo, i) => {
  const url = imagenDemo(titulo, i);
  return { key: `demo/${titulo.toLowerCase()}-${i + 1}.png`, nombre: `${titulo.toLowerCase()}-${i + 1}.png`, tipo: "image/png", tamano: 90000 + i * 7000, es_imagen: true, url, url_descarga: url };
};

const demoAvisos = [
  {
    avisos_id: 901,
    nombre: "Nueva experiencia de pagos",
    descripcion: "Actualizamos la plataforma para que encuentres más rápido tus operaciones y tengas toda la información importante en un solo lugar.",
    fecha_creacion: new Date(Date.now() - 12 * 60 * 1000).toISOString(),
    leido: false,
    archivos: [{ key: "demo/novedades-wee.png", nombre: "novedades-wee.png", tipo: "image/png", tamano: 184320, es_imagen: true, url: imagenMuestra, url_descarga: imagenMuestra }],
  },
  {
    avisos_id: 902,
    nombre: "Mantenimiento programado",
    descripcion: "El domingo entre las 02:00 y las 03:00 vamos a realizar tareas de mantenimiento. Durante ese período algunas funciones podrían estar temporalmente no disponibles.",
    fecha_creacion: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    leido: false,
    archivos: [archivoImg("Mantenimiento", 0), archivoImg("Mantenimiento", 1), { key: "demo/detalle-mantenimiento.pdf", nombre: "detalle-mantenimiento.pdf", tipo: "application/pdf", tamano: 73400, es_imagen: false, url: "data:application/pdf,%25PDF-1.4%0A%25Demo", url_descarga: "data:application/pdf,%25PDF-1.4%0A%25Demo" }],
  },
  {
    avisos_id: 903,
    nombre: "Comprobantes disponibles",
    descripcion: "Ya podés descargar el instructivo actualizado para consultar y exportar tus comprobantes desde la sección de movimientos.",
    fecha_creacion: new Date(Date.now() - 25 * 60 * 60 * 1000).toISOString(),
    leido: true,
    archivos: [{ key: "demo/guia-comprobantes.docx", nombre: "guia-comprobantes.docx", tipo: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", tamano: 281000, es_imagen: false, url: "data:application/octet-stream,Archivo%20Word%20de%20muestra", url_descarga: "data:application/octet-stream,Archivo%20Word%20de%20muestra" }],
  },
  {
    avisos_id: 904,
    nombre: "Nuevos medios de pago",
    descripcion: "Incorporamos nuevas opciones para que tus clientes puedan elegir cómo pagar. Revisá los medios habilitados desde la configuración de tu cuenta. Desde ahora podés aceptar pagos con billeteras virtuales, transferencias inmediatas y tarjetas de débito prepagas, y ver cada operación en tiempo real desde tu panel. Si tenés dudas sobre cómo activarlos, escribinos al soporte de la plataforma y te acompañamos en el proceso.",
    fecha_creacion: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    leido: false,
    archivos: [0, 1, 2, 3, 4, 5, 6].map((i) => archivoImg("Medio de pago", i)),
  },
  {
    avisos_id: 905,
    nombre: "Actualización de seguridad",
    descripcion: "Te recomendamos mantener actualizados los datos de contacto de tu cuenta para recibir avisos importantes y proteger el acceso.",
    fecha_creacion: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    leido: true,
    archivos: [{ key: "demo/recomendaciones.csv", nombre: "recomendaciones.csv", tipo: "text/csv", tamano: 12400, es_imagen: false, url: "data:text/csv,Recomendacion%2CDetalle", url_descarga: "data:text/csv,Recomendacion%2CDetalle" }],
  },
];

function respuestaDemo(params = {}) {
  const filtrados = demoAvisos
    .filter((aviso) => params.leido === undefined || aviso.leido === params.leido)
    .sort((a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion));
  const page = Math.max(1, Number(params.Number) || 1);
  const size = Math.max(1, Number(params.Size) || 10);
  const avisos = filtrados.slice((page - 1) * size, page * size);
  return Promise.resolve({
    data: {
      data: {
        Avisos: avisos,
        meta: { page: { currentPage: page, lastPage: Math.max(1, Math.ceil(filtrados.length / size)) } },
      },
    },
  });
}

export const Notificaciones = {
  // Obtener todos los avisos
  getAvisos(params) {
    if (esDemoAvisos()) return respuestaDemo(params);
    return axios.get(PASARELA + "/administracion/avisos", { params });
  },

  // Para manejar el leído de notificación
  putCambiarEstadoAviso(params) {
    if (esDemoAvisos()) {
      const aviso = demoAvisos.find((item) => item.avisos_id === Number(params.AvisoId));
      if (aviso) aviso.leido = true;
      return Promise.resolve({ data: { ok: true, demo: true } });
    }
    const url = `${PASARELA}/administracion/avisos-leido?AvisoId=${params.AvisoId}&UserId=${params.UserId}`;
    return axios.put(url);
  },

  // Crear un nuevo aviso
  createAviso(payload) {
    if (esDemoAvisos()) return Promise.resolve({ data: { ...payload, demo: true } });
    return axios.post(PASARELA + "/administracion/avisos", payload);
  },

  // Actualizar un aviso existente
  putAviso(payload) {
    if (esDemoAvisos()) return Promise.resolve({ data: { demo: true } });
    return axios.put(PASARELA + "/administracion/avisos", payload);
  },

  // Eliminar aviso
  deleteAviso(params) {
    if (esDemoAvisos()) return Promise.resolve({ data: { ok: true, demo: true } });
    return axios.delete(PASARELA + "/administracion/avisos", { params });
  },
};
